import React from "react";

export default function BackButton(props) {
    return <button className="btn btn-light mb-3 ml-1" onClick={ props.onClick }><span className="oi oi-arrow-left mr-2"></span>Back</button>
}